module.exports = __webpack_public_path__ + "static/media/Promotions.7c789585.webp";